export const LOAD_DATA = 'TABLE_DOCTORS/LOAD_DATA';
export const FILTER_DATA = 'TABLE_DOCTORS/FILTER_DATA';
